export const CHANGE_NECTAR_ACCOUNT_FLAG = "changeNectarAccount";
export const WEB_AUTHN_FLAG = "webAuthn";
export const SSO_FLAG = "singleSignOn";
